import React from 'react'
import './lines.css'
import {AiOutlineClockCircle} from 'react-icons/ai'
import {GoLocation} from 'react-icons/go'
import {BsWhatsapp} from 'react-icons/bs'

const Lines = () => {
  return (
    <section id='lines'>
        <div className="lines__container">

            <article className='line'>
            <BsWhatsapp className='line__icon' />
            <div className="line__head">
                
                <h2>TELEFONOS</h2>
                <h4>4462-6559</h4>
                <h4>2105-9222</h4>
            </div>          
            </article>

            <article className='line'>
            <AiOutlineClockCircle className='line__icon' />
            <div className="line__head">
                
            
                <h2>HORARIO</h2>
                <h4>Lunes a Domingo:</h4>
                <h4>De 7 a 20:30</h4>
            </div>
            </article>

            <article className='line'>
            <GoLocation className='line__icon' />
            <div className="line__head">
            
                
                <h2>UBICACION</h2>
                <h4>Ciudad Madero</h4>
                <h4>Av Velez Sarsfield 1234</h4>
            </div>
            </article>
        </div>
    </section>
  )
}

export default Lines